// src/components/HomeButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeButton({ children = 'Voltar', className = '' }) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/')}
      className={`logout-button`}
      title="Voltar para a página inicial"
    >
      {children}
    </button>
  );
}
